export interface SettingsState {
  profileMenuCollapsed: boolean;
  unreadChatMessageCount: number;
  newMissions: boolean;
  cancelCrafting: boolean | undefined;
}

export const settingsDefault: SettingsState = {
  profileMenuCollapsed: false,
  unreadChatMessageCount: 0,
  newMissions: false,
  cancelCrafting: undefined,
};
